import { navigate } from '../lib/route.js';

// Illustrated wordmark for the splash hero (transparent, with its own soft glow).
export const LOGO_ART = '/art/logo-schemer.webp';

export function SplashScreen(): React.JSX.Element {
  return (
    <main className="splash with-hero">
      <div className="splash-hero" aria-hidden="true">
        {/* lowercase `fetchpriority` is what the DOM expects; React 18 warns on
            the camelCase variant. */}
        <img
          src="/images/03-hero-village-dusk.jpg"
          alt=""
          loading="eager"
          {...({ fetchpriority: 'high' } as { fetchpriority: string })}
        />
        <div className="splash-hero-fade" />
      </div>
      <div className="splash-content">
        {/* The illustrated wordmark IS the title, so it stays inside the h1 and
            carries real alt text — a screen reader still reads "Schemer" and the
            heading outline is unchanged. The small in-game header stays text. */}
        <h1 className="splash-logo">
          <img src={LOGO_ART} alt="Schemer" width={976} height={393} />
        </h1>
        {/* 3: a newcomer needs to know what this IS. "Willowbrook" is only a place
            name and says nothing yet, so the tagline takes its slot here; the
            village name carries on every in-game screen. */}
        <p className="tagline">
          Een spel van vuur, vertrouwen en verraad — met je familie, over meerdere dagen.
        </p>
        <div className="cta-stack">
          <button className="cta primary" onClick={() => navigate({ name: 'create' })}>
            Nieuw spel
          </button>
          <button className="cta" onClick={() => navigate({ name: 'join' })}>
            Meedoen met een code
          </button>
        </div>
        <button className="splash-help" onClick={() => navigate({ name: 'help' })}>
          Hoe werkt het?
        </button>
      </div>
    </main>
  );
}
